<template>
  <div v-if="loaded" class="ver-page">
    <div class="coupon-detail" :style="{ 'width':this.$store.state.clientWidth + 'px' }">
      <img class="coupon" :src="cover | filterPicture" />
      <div class="desc">
        <h4>使用规则</h4>
        <h6 v-html="rule"></h6>
        <h4>用户信息</h4>
        <h6>
          <span style="width: 70px; display: inline-block">姓名：</span>{{ name }}<br/>
          <span style="width: 70px; display: inline-block">{{ cardName }}：</span>{{ card }}
        </h6>
      </div>

      <div class="prize-form" v-if="type !== 'PRIZE'">
        <h4>核销信息</h4>
        <van-field readonly clickable name="picker" :value="estate.name" label="楼盘" placeholder="点击选择楼盘" @click="showPicker" />
        <van-field v-model="estateDesc" label="房源"  placeholder="房源" :disabled="btnDisabled" />
      </div>

      <div class="submit-btn">
        <van-button @click="onSubmit" type="danger" size="normal" :disabled="btnDisabled">提交</van-button>
      </div>
    </div>

    <van-popup v-model="pickerVisible" position="bottom">
      <van-picker show-toolbar :loading="loading" :columns="estates" @confirm="onConfirm" @cancel="pickerVisible = false" value-key="name" />
    </van-popup>
  </div>
</template>

<script>
import { getUrlKeys } from '@/utils/index'

export default {
  data () {
    return {
      loaded: false,
      cover: '',
      rule: '',
      code: '',
      name: '',
      card: '',
      cardName: '',
      type: '',
      
      estateDesc: '',
      pickerVisible: false,
      loading: true,
      btnDisabled: false,
      estate: {},
      estates: []
    }
  },

  created () {
    this.initData()
    console.log('hola')
  },

  methods: {
    initData () {
      window.document.title = '核销'
      this.toast.loading({ duration: 0, message: '', forbidClick: true })

      const dataArr = this.$route.params.data.split('-')

      this.id = dataArr[0]
      this.code = dataArr[1]

      if (!this.code || !this.id) {
        this.btnDisabled = true
        return this.toast.fail('未知的核销码')
      }

      this.request({
        url: '/liveReceive/detail/' + this.id,
        data: {},
      }).then(res => {
        this.toast.clear()

        if (res.result) {
          this.loaded = true

          this.type = res.result.type
          if (this.type === 'PRIZE') {
            this.cover = res.result.livePrizeDetail.imageDetail
            this.rule = res.result.livePrizeDetail.rules.replace(/\n|\r\n/g, '<br>')
            this.name = res.result.memberDetail.realName
            this.card = res.result.memberDetail.mobile
            this.cardName = '手机号'
          } else {
            this.cover = res.result.liveVoucherDetail.imageDetail
            this.rule = res.result.liveVoucherDetail.rules.replace(/\n|\r\n/g, '<br>')
            this.name = res.result.memberName
            this.card = res.result.memberPassport || res.result.memberIdcard
            this.cardName = '证件号'
          }
        }

          if (res.result.status === 'UESD') {
            this.toast('卡券已核销，请勿重复核销')

            this.estate = res.result.useBuildingDetail
            this.estateDesc = res.result.useBuildingItem

            this.btnDisabled = true
          }
      })

      this.request({
        url: '/liveBuilding/auth/list',
        data: {},
      }).then(res => {
        this.loading = false
        this.estates = res.result.rows
      })
    },

    showPicker () {
      if (!this.btnDisabled) {
        this.pickerVisible = true
      }
    },

    onConfirm (row) {
      this.estate = row
      this.pickerVisible = false
    },

    onSubmit () {
      this.toast.loading({ duration: 0, message: '', forbidClick: true })
      let submitForm = { useCode: this.code, type: this.type }

      if (this.type !== 'PRIZE') {
        submitForm.useBuildingId = this.estate.id
        submitForm.useBuildingItem = this.estateDesc
      }

      this.request({
        url: '/liveVoucher/use',
        data: submitForm,
      }).then(res => {
        this.toast.clear()
        this.toast.success('核销成功')
        this.btnDisabled = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ver-page {
  width: 100%;
  min-height: 100vh;
  background-color: #FFF;
}

.coupon-detail {
  padding: 30px 20px 0;
  h4 {
    margin: 20px 0 10px;
    font-size: 16px;
    color: #D8323F;
  }
  .coupon {
    width: 100%;
  }
  .desc {
    h6 {
      font-size: 14px;
      line-height: 26px;
      counter-reset: #4D4D4D;
    }
    .qrcode {
      display: block;
      margin: 0 auto 20px;
      width: 150px;
    }
  }
}
</style>

<style lang="scss">
.prize-form {
  .van-field {
    display: flex;
    align-items: center;
    margin-bottom: .24rem;
    padding: 0 .25rem;
    height: .8rem;
    background: #F5F5F5;
    .van-field__label {
      height: .3rem;
      font-size: .3rem;
      line-height: .3rem;
      border-right: 1px solid #EB6757;
      color: #EB6757;
    }
    .van-cell__value {
      margin-left: .25rem;
    }
  }
}

.submit-btn {
  margin: .5rem auto;
  text-align: center;
  button {
    width: 4.2rem;
    height: .88rem;
    border-radius: .4rem;
    background-color: #D7313F;
  }
}
</style>